import React from "react";

export enum HeadingSize {
    MEDIUM = "medium",
    SMALL = "small",
    LARGE = "large",
}

export enum HeadingWeight {
    BOLD = "bold",
    SEMIBOLD = "semibold",
    NORMAL = "normal",
}

export type HeadingProps = {
    /**
     * The size of the heading (MEDIUM | SMALL).
     * @default MEDIUM
     */
    size?: HeadingSize;
    /**
     * The weight of the heading (BOLD | SEMIBOLD | NORMAL).
     * @default NORMAL
     */
    weight?: HeadingWeight;
    /**
     * The color of the heading. This is a string that should be a valid CSS color.
     * @default inherit
     */
    color?: string;
    /**
     * The alignment of the heading. This can be any valid CSS textAlign value.
     * @default inherit
     */
    align?: CSSStyleDeclaration["textAlign"];

    /**
     * If true, the heading will be uppercase.
     * @default false
     */
    uppercase?: boolean;
} & React.HTMLAttributes<HTMLHeadingElement>;

export type DefaultHeadingProps = {
    size: NonNullable<HeadingProps["size"]>;
    weight: NonNullable<HeadingProps["weight"]>;
    color: NonNullable<HeadingProps["color"]>;
    align: NonNullable<HeadingProps["align"]>;
};
